// Cosa fa il tasto indietro di Android: chiude il dialog aperto; sulla pagina iniziale e
// sulla dashboard esce dall'app; altrove torna alla pagina precedente.
export function azioneTastoIndietro({ percorso, dialogAperti }) {
  if (dialogAperti) return "chiudi-dialog";
  if (percorso === "/" || percorso?.startsWith("/admin/dashboard")) return "esci";
  return "indietro";
}
